import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {omit} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {enable302ResponseState} from "@pg-mono/response-state";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {IRPRequestMeta} from "../../../app/rp_request_meta";

export const redirectInvestmentFromListToMap = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

    const cookiesObject = ctx.req?.cookies;
    const variantString = cookiesObject && cookiesObject[abTestProps.id];
    const parsedVariant = variantString && Number(variantString);

    const query = ctx.route.query;

    const hasUserSelectedList = query.sol && query.sol === "true";
    const redirectQuery = omit(query, ["sol"]);

    if (parsedVariant && !isNaN(parsedVariant) && parsedVariant === 1 && !hasUserSelectedList) {
        dispatch(enable302ResponseState(appendQueryString(ctx.route.pathname + "mapa/", redirectQuery)));
        return false;
    }

    return true;
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {omit} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {enable302ResponseState} from "@pg-mono/response-state";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {IRPRequestMeta} from "../../../app/rp_request_meta";

export const redirectInvestmentFromListToMap = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

    const cookiesObject = ctx.req?.cookies;
    const variantString = cookiesObject && cookiesObject[abTestProps.id];
    const parsedVariant = variantString && Number(variantString);

    const query = ctx.route.query;

    const hasUserSelectedList = query.sol && query.sol === "true";
    const redirectQuery = omit(query, ["sol"]);

    if (parsedVariant && !isNaN(parsedVariant) && parsedVariant === 1 && !hasUserSelectedList) {
        dispatch(enable302ResponseState(appendQueryString(ctx.route.pathname + "mapa/", redirectQuery)));
        return false;
    }

    return true;
};
